import { useState, useCallback, useEffect } from "react";
import { Link } from "react-router-dom";

const API_URL = "https://pro-erp-system.stacknet.lk/items/api/public";

const toSlug = (name) =>
  name.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "");

const fixedLinks = [
  { name: "Home", path: "/" },
  { name: "Shop", path: "/shop" },
];

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [dynamicCategories, setDynamicCategories] = useState([]);

  const toggleMenu = useCallback(() => setIsOpen((p) => !p), []);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    fetch(API_URL)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setDynamicCategories(
            data.categories.map((cat) => ({
              name: cat.name,
              path: `/${toSlug(cat.name)}`,
            }))
          );
        }
      })
      .catch(() => {});
  }, []);

  const allLinks = [...fixedLinks, ...dynamicCategories];

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@400;600;700;800;900&family=Barlow:wght@400;500;600&display=swap');
        .nav-link {
          color: #d1d5db;
          font-size: 0.85rem;
          font-weight: 600;
          text-decoration: none;
          letter-spacing: 0.1em;
          text-transform: uppercase;
          font-family: 'Barlow', sans-serif;
          transition: color 0.2s;
        }
        .nav-link:hover { color: #ef4444; }
        .drawer-link {
          color: #d1d5db;
          font-size: 1rem;
          font-weight: 600;
          text-decoration: none;
          letter-spacing: 0.08em;
          text-transform: uppercase;
          font-family: 'Barlow', sans-serif;
          padding: 0.6rem 0;
          border-bottom: 1px solid #1f1f1f;
          transition: color 0.2s;
        }
        .drawer-link:hover { color: #ef4444; }
      `}</style>

      <header style={{ position: "sticky", top: 0, zIndex: 999 }}>
        <nav style={{
          background: scrolled ? "rgba(8,8,8,0.97)" : "#080808",
          backdropFilter: scrolled ? "blur(12px)" : "none",
          borderBottom: "1px solid #1f1f1f",
          transition: "all 0.3s ease",
          padding: "0 2rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          height: "64px",
          fontFamily: "'Barlow Condensed', 'Impact', sans-serif",
        }}>

          {/* LOGO */}
          <Link to="/" style={{ display: "flex", alignItems: "center", gap: "10px", textDecoration: "none" }}>
            <img
              src="https://res.cloudinary.com/dwf8ifbzs/image/upload/v1741282821/Pro_Nutrition-01-removebg-preview_thyf18.png"
              alt="Logo"
              style={{ height: "38px", width: "38px", objectFit: "contain" }}
            />
            <span style={{ fontSize: "1.3rem", fontWeight: 900, letterSpacing: "0.1em", color: "#fff" }}>
              PRO <span style={{ color: "#ef4444" }}>NUTRITION</span>
            </span>
          </Link>

          {/* DESKTOP NAV */}
          <div style={{ display: "flex", gap: "2rem" }} className="desktop-nav">
            {allLinks.map((item) => (
              <Link key={item.path} to={item.path} className="nav-link">
                {item.name}
              </Link>
            ))}
          </div>

          {/* CONTACT */}
          <div style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
            fontFamily: "'Barlow', sans-serif",
          }} className="desktop-contact">
            <span style={{ color: "#fff", fontSize: "0.85rem", fontWeight: 600, letterSpacing: "0.05em" }}>
              +94 76 579 4062
            </span>
            <span style={{ color: "#6b7280", fontSize: "0.75rem" }}>Moratuwa, Sri Lanka</span>
          </div>

          {/* MOBILE BUTTON */}
          <button
            onClick={toggleMenu}
            style={{
              display: "none",
              background: "none",
              border: "none",
              color: "#fff",
              fontSize: "1.6rem",
              cursor: "pointer",
              lineHeight: 1,
            }}
            className="mobile-btn"
          >
            {isOpen ? "×" : "≡"}
          </button>
        </nav>

        <style>{`
          @media (max-width: 768px) {
            .desktop-nav, .desktop-contact { display: none !important; }
            .mobile-btn { display: block !important; }
          }
        `}</style>
      </header>

      {/* MOBILE DRAWER */}
      {isOpen && (
        <div
          style={{
            position: "fixed", inset: 0, zIndex: 1000,
            background: "rgba(0,0,0,0.7)",
          }}
          onClick={toggleMenu}
        />
      )}
      <div style={{
        position: "fixed", top: 0, left: 0,
        width: "280px", height: "100%",
        background: "#0f0f0f",
        borderRight: "1px solid #1f1f1f",
        zIndex: 1001,
        transform: isOpen ? "translateX(0)" : "translateX(-100%)",
        transition: "transform 0.3s ease",
        display: "flex",
        flexDirection: "column",
        fontFamily: "'Barlow Condensed', sans-serif",
      }}>
        {/* Drawer header */}
        <div style={{
          padding: "1.25rem 1.5rem",
          borderBottom: "1px solid #1f1f1f",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}>
          <span style={{ fontSize: "1.1rem", fontWeight: 900, letterSpacing: "0.1em", color: "#fff" }}>
            PRO <span style={{ color: "#ef4444" }}>NUTRITION</span>
          </span>
          <button onClick={toggleMenu} style={{
            background: "none", border: "none",
            color: "#9ca3af", fontSize: "1.5rem", cursor: "pointer",
          }}>×</button>
        </div>

        {/* Drawer links */}
        <div style={{ padding: "1rem 1.5rem", flex: 1, display: "flex", flexDirection: "column", gap: "0.25rem" }}>
          {allLinks.map((item) => (
            <Link key={item.path} to={item.path} onClick={toggleMenu} className="drawer-link"
              style={{ display: "block" }}>
              {item.name}
            </Link>
          ))}
        </div>

        {/* Drawer footer */}
        <div style={{
          padding: "1.25rem 1.5rem",
          borderTop: "1px solid #1f1f1f",
          fontFamily: "'Barlow', sans-serif",
        }}>
          <div style={{
            display: "inline-block",
            background: "#ef4444",
            color: "#fff",
            fontSize: "0.65rem",
            fontWeight: 700,
            letterSpacing: "0.15em",
            padding: "3px 10px",
            borderRadius: "2px",
            textTransform: "uppercase",
            marginBottom: "0.5rem",
          }}>Sri Lanka's #1 Supplement Store</div>
          <p style={{ color: "#fff", fontSize: "0.85rem", fontWeight: 600 }}>+94 76 579 4062</p>
          <p style={{ color: "#6b7280", fontSize: "0.75rem" }}>Rawatawatta, Moratuwa, Sri Lanka</p>
        </div>
      </div>
    </>
  );
}